













































































import {Vue, Component} from 'vue-property-decorator';
import {toI18n} from '@/utils/commonUtils';

@Component
export default class BatchConfirm extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }

  private judgementRadio = 'CONFIRM';
  private rejectReasonYn = false;
  private rejectReason = '';
  private isError = false;

  private get mallProductNos(): string[] {
    return this.$route.params.mallProductNos.split(',');
  }

  private judegmentChange() {
    if (this.judgementRadio === 'CONFIRM') {
      this.rejectReasonYn = false;
      this.isError = false;
    }
  }

  private save() {
    if (this.rejectReasonYn && this.rejectReason.trim() === '') {
      this.isError = true;
      return;
    }

    const data: any = {
      isConfirm: this.judgementRadio === 'CONFIRM',
      mallProductNos: this.mallProductNos,
      reasonForReject: this.rejectReason
    };

    this.$api.putInspections({data}).then(({data}: any): void => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      Object.assign(data, {type: this.judgementRadio})
      window.opener.postMessage({batchConfirm: true, data});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup', 'popup_medium');
    window.name = 'batchJudgment';
  }
}
